import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _8accbb00 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _d3c0eed0 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _f961416e = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _40397a20 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _43173a64 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _4729781a = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _1334c703 = () => interopDefault(import('../src/pages/initial-settings/preferences.vue' /* webpackChunkName: "pages/initial-settings/preferences" */))
const _68c7a1ac = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _f9e6954e = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _007cf3ad = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _42a4e594 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _51d38a50 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _3fc33169 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _89748d20 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _6c61a401 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _832d5544 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _0878aba4 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _3fc01db8 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _6ce92e18 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _fecf3cf8 = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _693d1bf2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _fc684cc6 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _6eb83aab = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _4570e223 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _34bc4be9 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _4eb064dc = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _1ec97080 = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _1e576d00 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _46351a4c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _f93a2446 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _53cf9971 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _635de6c8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _65b33298 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _fd644554 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _6f22031f = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _1798c78a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports" */))
const _127a6242 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _4615e885 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _c3c9a902 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _4a9167f1 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _b921a616 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _45488978 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _7cfcd016 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _73ff05e8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _2a18ad7e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _199654d6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _5ffca63d = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _0c03ac2b = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _04eb809c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _3850c6a8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _e86e56c2 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _8a2f7dc0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _65e87994 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _e2728266 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _5ed06b55 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _15b4de08 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _4ff8a9cc = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _a25ba814 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _69ef6444 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _7250a5a8 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _3b6686cc = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _33c1f398 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _8accbb00,
      name: "companies"
    }, {
      path: "/logout",
      component: _d3c0eed0,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _f961416e,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _40397a20,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _43173a64,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _4729781a,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/preferences",
      component: _1334c703,
      name: "initial-settings-preferences"
    }, {
      path: "/initial-settings/user-profile",
      component: _68c7a1ac,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/callback",
      component: _f9e6954e,
      name: "sessions-callback"
    }, {
      path: "/sessions/invitation",
      component: _007cf3ad,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _42a4e594,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _51d38a50,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _3fc33169,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _89748d20,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _6c61a401,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _832d5544,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _0878aba4,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _3fc01db8,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _6ce92e18,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _fecf3cf8,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _693d1bf2,
      name: "companies-company_id-projects"
    }, {
      path: "/companies/:company_id/reports",
      component: _fc684cc6,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _6eb83aab,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _4570e223,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _34bc4be9,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _4eb064dc,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/projects/new",
      component: _1ec97080,
      name: "companies-company_id-projects-new"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _1e576d00,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/projects/:id",
      component: _46351a4c,
      children: [{
        path: "",
        component: _f93a2446,
        name: "companies-company_id-projects-id"
      }, {
        path: "attendance",
        component: _53cf9971,
        name: "companies-company_id-projects-id-attendance"
      }, {
        path: "board_posts",
        component: _635de6c8,
        name: "companies-company_id-projects-id-board_posts"
      }, {
        path: "card",
        component: _65b33298,
        name: "companies-company_id-projects-id-card"
      }, {
        path: "detail",
        component: _fd644554,
        name: "companies-company_id-projects-id-detail"
      }, {
        path: "member",
        component: _6f22031f,
        name: "companies-company_id-projects-id-member"
      }, {
        path: "reports",
        component: _1798c78a,
        name: "companies-company_id-projects-id-reports"
      }, {
        path: "schedule",
        component: _127a6242,
        name: "companies-company_id-projects-id-schedule"
      }, {
        path: "attendance/summary",
        component: _4615e885,
        name: "companies-company_id-projects-id-attendance-summary"
      }, {
        path: "attendance/user-list",
        component: _c3c9a902,
        name: "companies-company_id-projects-id-attendance-user-list"
      }, {
        path: "attendance/user-records",
        component: _4a9167f1,
        name: "companies-company_id-projects-id-attendance-user-records"
      }, {
        path: "attendance/utils",
        component: _b921a616,
        name: "companies-company_id-projects-id-attendance-utils",
        children: [{
          path: "user-list",
          component: _45488978,
          name: "companies-company_id-projects-id-attendance-utils-user-list"
        }]
      }, {
        path: "board_posts/new",
        component: _7cfcd016,
        name: "companies-company_id-projects-id-board_posts-new"
      }, {
        path: "board_posts/posts",
        component: _73ff05e8,
        name: "companies-company_id-projects-id-board_posts-posts"
      }, {
        path: "schedule/fullscreen",
        component: _2a18ad7e,
        name: "companies-company_id-projects-id-schedule-fullscreen"
      }, {
        path: "schedule/preview",
        component: _199654d6,
        name: "companies-company_id-projects-id-schedule-preview"
      }, {
        path: "schedule/print",
        component: _5ffca63d,
        name: "companies-company_id-projects-id-schedule-print"
      }, {
        path: "schedule/view",
        component: _0c03ac2b,
        name: "companies-company_id-projects-id-schedule-view"
      }, {
        path: "schedule/view/fullscreen",
        component: _04eb809c,
        name: "companies-company_id-projects-id-schedule-view-fullscreen"
      }, {
        path: "board_posts/:board_id",
        component: _3850c6a8,
        name: "companies-company_id-projects-id-board_posts-board_id"
      }, {
        path: "files/:file_id",
        component: _e86e56c2,
        name: "companies-company_id-projects-id-files-file_id"
      }, {
        path: "board_posts/:board_id/edit",
        component: _8a2f7dc0,
        name: "companies-company_id-projects-id-board_posts-board_id-edit"
      }, {
        path: "board_posts/:board_id/files",
        component: _65e87994,
        name: "companies-company_id-projects-id-board_posts-board_id-files"
      }, {
        path: "files/:file_id/edit",
        component: _e2728266,
        name: "companies-company_id-projects-id-files-file_id-edit"
      }, {
        path: "files/:file_id/preview",
        component: _5ed06b55,
        name: "companies-company_id-projects-id-files-file_id-preview"
      }]
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _15b4de08,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _4ff8a9cc,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _a25ba814,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _69ef6444,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _7250a5a8,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _3b6686cc,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _33c1f398,
      name: "index"
    }],

    fallback: false
  })
}
